function WarningMessage(props) {
  const { userEmail } = props;

  return (
    <div>
      <p>
        This is the third consecutive failed attempt to login with email address <b>{userEmail}</b>.
      </p>
      <p>If an account exists with this email address, it will be locked after two more failed login attempts.</p>
      <p>Check your email and password credentials carefully before trying to log in again.</p>
      <hr />
    </div>
  );
}

export default WarningMessage;
